var map = {
	"./multiplier_128_win.png": 78161,
	"./multiplier_16_win.png": 40708,
	"./multiplier_1_win.png": 13627,
	"./multiplier_2_win.png": 59076,
	"./multiplier_32_win.png": 1945,
	"./multiplier_4_win.png": 63370,
	"./multiplier_64_win.png": 19100,
	"./multiplier_8_win.png": 65678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27588;